<template>
<billinghistory :billingHistory="billingSummary">
    </billinghistory>
    
</template>

<script>
import Api from "@/services/Api";
import BillingHistory from '@/components/BillingHistory.vue';
export default {
    components:{
        billinghistory: BillingHistory
    },
    data(){
        return{
            billingDetails: false,
            billingSummary:[],
        }
    },
    created(){
            Api()
            .get('/billingHistorySummary')
            .then(response=>{
                this.billingSummary=response.data
            });
    },
    methods:{
        
        }
}
</script>